<template>
  <span :class="['label', `label-pricerequest-type-${type}`]">{{type | formatLookupName(PriceRequestTypeLookup)}}</span>
</template>

<script>
import { PriceRequestTypeLookup } from '@/store/types'

export default {
  name: 'LabelPriceRequestTypeBadge',
  props: {
    type: String
  },
  created() {
    this.PriceRequestTypeLookup = PriceRequestTypeLookup
  },
}
</script>
